import { DynamicFormattedMessage } from '@cedalo/webui/src/components/HelperComponent/DynamicFormattedMessage';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { userShape } from './UserPropTypes';

const USER_TABLE_COLUMNS = [
	{ id: 'username', key: 'Admin.User.username' },
	{ id: 'email', key: 'Admin.User.email' },
	{ id: 'firstName', key: 'Admin.User.firstName' },
	{ id: 'lastName', key: 'Admin.User.lastName' },
	{ id: 'type', key: 'Extensions.Admin.User.Type' },
	{ id: 'lastModified', key: 'Admin.User.lastModified' }
];

const FormattedUserType = (props) => {
	switch (props.provider) {
		case 'local':
			return <FormattedMessage id="Extensions.Admin.User.Type.Local" defaultMessage="Local" />;
		default:
			return props.provider || '';
	}
};

export const UserTable = (props) => {
	const { users, onDeleteUser, onSelectUser, onSort, sortBy, sortDirection } = props;

	return (
		<Table size="small" style={{marginTop: '25px'}}>
			<TableHead>
				<TableRow>
					{USER_TABLE_COLUMNS.map((column) => (
						<TableCell
							padding="none"
							key={column.id}
							sortDirection={sortBy === column.id ? sortDirection : false}
						>
							<TableSortLabel
								active={sortBy === column.id}
								direction={sortDirection}
								onClick={() => onSort(column.id)}
							>
								<DynamicFormattedMessage id={column.key} defaultMessage={column.key} />
							</TableSortLabel>
						</TableCell>
					))}
					<TableCell />
				</TableRow>
			</TableHead>
			<TableBody>
				{users.map((user) => (
					<TableRow hover key={user.id} onClick={() => onSelectUser(user.id)} style={{ cursor: 'pointer', height: '45px' }}>
						<TableCell padding="none">
							<b>{user.username}</b>
						</TableCell>
						<TableCell padding="none">{user.email}</TableCell>
						<TableCell padding="none">{user.firstName}</TableCell>
						<TableCell padding="none">{user.lastName}</TableCell>
						<TableCell padding="none">
							<FormattedUserType provider={user.provider} />
						</TableCell>
						<TableCell padding="none">{moment(user.lastModified).fromNow()}</TableCell>
						<TableCell padding="none">
							{user.canDelete ? (
								<IconButton
									style={{ color: '#FF0022' }}
									onClick={(event) => {
										event.stopPropagation();
										onDeleteUser(user.id);
									}}
								>
									<DeleteIcon />
								</IconButton>
							) : null}
						</TableCell>
					</TableRow>
				))}
			</TableBody>
		</Table>
	);
};

UserTable.propTypes = {
	users: PropTypes.arrayOf(userShape).isRequired,
	sortBy: PropTypes.string,
	sortDirection: PropTypes.string,
	onDeleteUser: PropTypes.func.isRequired,
	onSelectUser: PropTypes.func.isRequired,
	onSort: PropTypes.func.isRequired
};

UserTable.defaultProps = {
	sortBy: undefined,
	sortDirection: undefined
};



// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/webui-extensions/src/user/UserTable.js